import { ValidarEmailHelper } from "../../../helpers";
const validarEmailHelper = new ValidarEmailHelper();

export class BancoCaixa {
  nome = null;
  tipoConta = null;
  dataSaldoInicial = null;
  saldoInicial = null;
  bancoId = null;
  agencia = null;
  digitoAgencia = null;
  aberturaAutomatica = false;
  conta = null;
  digitoConta = null;
  codigoBeneficiario = null;
  contato = null;
  diasCarencia = null;
  chavePix = null;
  nomeGerente = null;
  telefoneGerente = null;
  emailGerente = null;
  ativado = true;
  caixaBanco = false;
  contaBancariaTipo = null;
  codigoBancoCorrespondente = null;
  codigoEmpresa = null;
  emissaoBoleto = false;
  boletoHabilitado = null;
  responsaveisList = [];
  convenios = [];
  empresasAcessoIds = [];

  constructor(dadosBancoCaixa, id) {
    this.empresasAcessoIds = dadosBancoCaixa.empresasAcessoIds ?? [];
    this.nome = dadosBancoCaixa.nome;
    this.tipoConta = dadosBancoCaixa.tipoConta;
    this.dataSaldoInicial = dadosBancoCaixa.dataSaldoInicial;
    this.saldoInicial = dadosBancoCaixa.saldoInicial;
    this.aberturaAutomatica = dadosBancoCaixa.aberturaAutomatica || false;
    this.chavePix = dadosBancoCaixa.chavePix;
    this.nomeGerente = dadosBancoCaixa.nomeGerente;
    this.telefoneGerente = dadosBancoCaixa.telefoneGerente;
    this.emailGerente = dadosBancoCaixa.emailGerente;
    this.ativado = dadosBancoCaixa.ativado;
    this.responsaveisList = dadosBancoCaixa.responsaveisList;
    this.caixaBanco = dadosBancoCaixa.caixaBanco ?? false;
    this.contaBancariaTipo = dadosBancoCaixa.contaBancariaTipo;
    this.codigoBancoCorrespondente = dadosBancoCaixa.codigoBancoCorrespondente;
    this.codigoEmpresa = dadosBancoCaixa.codigoEmpresa;
    this.emissaoBoleto = dadosBancoCaixa.emissaoBoleto;
    if (dadosBancoCaixa.caixaBanco || id) {
      this.bancoId = dadosBancoCaixa.bancoId;
      this.codigoBancario = dadosBancoCaixa.codigoBancario;
      this.agencia = dadosBancoCaixa.agencia;
      this.digitoAgencia = dadosBancoCaixa.digitoAgencia;
      this.conta = dadosBancoCaixa.conta;
      this.digitoConta = dadosBancoCaixa.digitoConta;
      this.codigoBeneficiario = dadosBancoCaixa.codigoBeneficiario;
      this.contato = dadosBancoCaixa.contato;
      this.diasCarencia = dadosBancoCaixa.diasCarencia;
      this.endereco = this.createEndereco(dadosBancoCaixa.endereco);
      this.boletoHabilitado = dadosBancoCaixa.boletoHabilitado;
      if (dadosBancoCaixa.emissaoBoleto) {
        this.convenios = dadosBancoCaixa.convenios;
      }
    }
  }

  createEndereco(endereco) {
    return {
      id: endereco.id,
      cep: endereco.cep,
      logradouro: endereco.logradouro,
      numero: endereco.numero,
      bairro: endereco.bairro,
      cidadeId: endereco.cidadeId
    }
  }

  validarEmail() {
    return validarEmailHelper.email(this.emailGerente);
  }
}
